export default __webpack_public_path__ + "static/media/28.b3ffce5b.jpg";